const compare = (a, b) => {
  return b - a;
};
const getValue = (message, criteria) => {
  return typeof criteria === "function" ? criteria(message) : message[criteria];
};
export const orderMessages = (messages, criteria) => {
  if (!messages || messages.length === 0 || !criteria) {
    return messages;
  }
  try {
    const messagesToSort = messages.slice();
    messagesToSort.sort((messageA, messageB) => {
      const a = getValue(messageA, criteria);
      const b = getValue(messageB, criteria);
      return compare(a, b);
    });
    return messagesToSort;
  } catch {
    return messages;
  }
};